<template>
  <div>
    <label class="form-label-div" v-if="numberOfObjects > 0">
      {{
        $t("ObjectToChange") +
          " " +
          numberOfObjects.toString() +
          " " +
          $tc("Object", 2).toLowerCase() +
          "?"
      }}
    </label>

    <label class="form-label-div" v-else>
      {{ $t("NoObjectToChange") }}
    </label>

    <div style="margin-top: 10px">
      <v-btn
        small
        text
        color="accent"
        class="button-processing ma-0"
        @click="$emit('change-to-default')"
      >
        {{ $t("Cancel") }}
      </v-btn>

      <v-btn
        small
        class="button-processing ma-0"
        v-if="numberOfObjects > 0"
        @click="$emit('finish-processing')"
      >
        {{ $t("Confirm") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProcessingWarning",

  props: {
    numberOfObjects: {
      type: Number
    }
  }
};
</script>

<style scoped>
.button-processing {
  font-size: 12px;
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectWindow/Processing/ProcessingWarning.vue